<template>
  <v-app class="custom_bg">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-title class="px-6">Edit User Profile</v-card-title>
            <v-card-text>
              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1">Name</span>
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  v-model="name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <span class="text-body-1">Telephone</span>
                <v-text-field
                  outlined
                  color="primary"
                  type="number"
                  dense
                  v-model="telephone"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6" class="py-0">
                <v-card-actions>
                  <v-snackbar v-model="alert" color="success">
                    Profile updated successfully
                  </v-snackbar>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    :loading="loading"
                    class="text-capitalize"
                    @click="save()"
                    >Save Changes</v-btn
                  >
                </v-card-actions>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Home",

  components: {},
  data: () => ({
    name: "",
    type: "",
    loading: false,

    alert: false,
    telephone: "",
    email: "",
  }),

  methods: {
    save() {
      this.loading = true;

      let data = {
        name: this.name,
        email: this.email,
        phone: this.telephone,
      };

      fetch("https://receipt.drecsoft.com/api/v1/user/update-profile", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.currentUser}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => {
          this.loading = false;
          this.alert = true;

          console.log(res.data);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },

    fUser() {
      fetch("https://receipt.drecsoft.com/api/v1/user/profile", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.currentUser}`,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          let docs = res.data.user;
          this.telephone = docs.phone;
          this.name = docs.name;
          this.email = docs.email;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  mounted() {
    this.fUser();
  },

  computed: {
    ...mapGetters(["getUser", "currentUser"]),
  },
};
</script>

<style  scoped>
.custom_bg {
  background: #f6f7ff;
}
</style>
